import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-inactive-listing',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <div class="inactive-container">
      <div class="message-card">
        <i class="fas fa-exclamation-circle"></i>
        <h1>Elan aktiv deyil</h1>
        <p>Axtardığınız elan artıq aktiv deyil və ya sistemdən silinib.</p>
        <a routerLink="/" class="btn-home">Ana səhifəyə qayıt</a>
      </div>
    </div>
  `,
  styles: [`
    .inactive-container {
      padding: 80px 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 400px;
    }
    .message-card {
      text-align: center;
      max-width: 400px;
      padding: 40px;
      background: #fff;
      border-radius: 16px;
      box-shadow: 0 10px 30px rgba(0,0,0,0.05);
    }
    .message-card i {
      font-size: 64px;
      color: #fab1a0;
      margin-bottom: 24px;
    }
    .message-card h1 {
      font-size: 24px;
      font-weight: 700;
      color: #2d3436;
      margin-bottom: 12px;
    }
    .message-card p {
      font-size: 16px;
      color: #636e72;
      margin-bottom: 32px;
    }
    .btn-home {
      display: inline-block;
      padding: 12px 32px;
      background: #007bff;
      color: white;
      text-decoration: none;
      border-radius: 8px;
      font-weight: 600;
      transition: background 0.2s;
    }
    .btn-home:hover { background: #0056b3; }
  `]
})
export class InactiveListingComponent {}
